import { Alert, AlertDescription, AlertTitle } from "ui/components/alert";

import { Icon } from "components";
import { LOCK } from "icons";
import { Link } from "react-router-dom";
import React from "react";
import { TIMESHEET_LOG_DAY_VIEW } from "@/lib/utils";

const LockAlert = ({ date, canEdit, isReviewed }) => {
  if (canEdit || isReviewed) {
    return null;
  }
  return (
    <Alert className="max-w-80">
      <Icon icon={LOCK} />
      <AlertTitle>Locked</AlertTitle>
      <AlertDescription>
        <p>
          This log is over 7 days old and the timesheet is now locked for this
          day, To unlock{" "}
          <Link
            to={`/${TIMESHEET_LOG_DAY_VIEW}/${date}`}
            className="underline text-blue-600"
          >
            Click here
          </Link>
        </p>
      </AlertDescription>
    </Alert>
  );
};

export default LockAlert;
